import { brand, contact, socials } from "@kanata/shared";
import { Seo, SITE_URL } from "@/components/Seo";
import { Hero } from "@/components/sections/Hero";
import { PromoBanner } from "@/components/sections/PromoBanner";
import { Products } from "@/components/sections/Products";
import { SetupInspiration } from "@/components/sections/SetupInspiration";
import { Offices } from "@/components/sections/Offices";
import { Reviews } from "@/components/sections/Reviews";

const TITLE = "Kanata Indonesia — Standing Desk Elektrik, Dibuat di Indonesia";
const DESCRIPTION =
  "Standing desk elektrik Karya dan aksesorinya. Harga jelas, ongkir dihitung dari alamat kamu, pemasangan tersedia di Jakarta, Tangerang, Depok, dan Bekasi. Dibuat di Indonesia.";

const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: brand.name,
  url: SITE_URL,
  description: DESCRIPTION,
  email: contact.email,
  address: {
    "@type": "PostalAddress",
    streetAddress: contact.showroom,
    addressRegion: "DKI Jakarta",
    addressCountry: "ID",
  },
  sameAs: [socials.instagram, socials.tiktok, socials.youtube, socials.linkedin],
};

export default function Home() {
  return (
    <>
      <Seo title={TITLE} description={DESCRIPTION} path="/" jsonLd={organizationSchema} />

      <main>
        <Hero />
        <Reviews />
        <PromoBanner />
        <Products />
        <SetupInspiration />
        <Offices />
      </main>
    </>
  );
}
